<template>
  <div class="table-list" v-loading="loading">
    <table>
      <thead>
        <tr>
          <th>UUID test</th>
          <th>Name client</th>
          <th>ID client (parent)</th>
          <th>Creation date
            <el-button
              size="mini"
              :type="sort['created_at'] ? 'primary' : ''"
              icon="el-icon-d-caret"
              @click="$emit('sort', 'created_at');" />
          </th>
          <th>Request</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!feedbackData.length">
          <td colspan="6" class="text-xs-center">No requests available</td>
        </tr>
        <tr v-for="item in feedbackData" :key="item.id" v-else>
          <td class="text-xs-center">
            <el-button
              type="text"
              class="table-size"
              @click="goToMore(item.message_uuid)">
              <span>{{ item.message_uuid }}</span>
            </el-button>
          </td>
          <td class="text-xs-center">{{ item.client_name }}</td>
          <td class="text-xs-center">
            <el-button type="text" class="table-size">
              <span @click="goToProfile(item.client_id)">
                {{ item.client_id }}
              </span>
              <span @click="goToProfile(item.client_parent_id)">
                ({{ item.client_parent_id }})
              </span>
            </el-button>
          </td>
          <td class="text-xs-center">{{ item.created_at | dateFilter }}</td>
          <td class="text-xs-center">{{ item.comment }}</td>
          <td class="text-xs-center">
            <div style="display: flex; align-items: center; gap: 8px">
              <el-button
                @click="
                  dialogVisible = true;
                  openedId = item.client_parent_id;
                "
                type="text">
                Notification
              </el-button>

              <el-button
                type="text"
                size="mini"
                @click="close(item.id)"
                :disabled="item.status === 1"
                :style="{ color: item.status ? '#95a5a6' : '#27ae60' }">
                {{ item.status === 1 ? "Closed" : "Done" }}
              </el-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <el-dialog
      title="Send notification"
      :visible.sync="dialogVisible"
      width="600px">
      <el-radio-group v-model="selectedOption" class="radio-group">
        <el-radio :label="1">
          <span class="radio-text">
            Thanks for reaching out! Your question is in progress, we will try
            to answer as soon as possible.
          </span>
        </el-radio>
        <el-radio :label="2">
          <span class="radio-text">
            Thanks for reaching out! Your coverage question has been forwarded
            to the Development Department.
          </span>
        </el-radio>
        <el-radio :label="3">
          <span class="radio-text">Other</span>
        </el-radio>
      </el-radio-group>

      <el-input
        v-if="selectedOption === 3"
        type="textarea"
        placeholder="Your comment.."
        v-model="customComment"
        rows="3"
        style="margin-top: 10px"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="sendNotification">Send</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "table-list",
  props: {
    feedbackData: {
      type: Array,
      default: () => [],
    },
    statuses: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
    sort: {
      Object,
    }
  },
  data() {
    return {
      dialogVisible: false,
      selectedOption: 1,
      customComment: "",
      openedId: null,
    };
  },
  methods: {
    async sendNotification() {
      let message = "";
      switch (this.selectedOption) {
        case 1:
          message =
            "Thanks for reaching out! Your question is in progress, we will try to answer as soon as possible";
          break;
        case 2:
          message =
            "Thanks for reaching out! Your coverage question has been forwarded to the Development Department.";
          break;
        case 3:
          message = this.customComment || "Other";
          break;
      }

      const { data } = await this.$http.post("/notification/create", {
        ids: [this.openedId],
        type: 5,
        text: message,

        send_to_all_users: false,
        send_only_parent: false,
        plan_type: null,
        postponed_at: null,
        title: "",
      });

      if (data.status === "success") {
        this.$message({
          type: "success",
          message: "Notification was sent",
        });
        this.openedId = null;
        this.dialogVisible = false;
        return;
      }

      this.$message({
        type: "error",
        message: "Something wrong",
      });
    },
    close: function (id) {
      this.$confirm("Are you sure?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(async () => {
          await this.$http.post(`/feedbacks/${id}/close`);
          this.$emit("refresh-requests");
        })
        .catch(() => {});
    },
    goToProfile(id) {
      this.$router.push({ name: "user-profile", params: { id } });
    },
    goToMore(id) {
      this.$router.push({ name: "sms-report-id", params: { id } });
    },
  },
};
</script>

<style>
.radio-group {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
  max-width: 100%;
  margin-top: 24px;
}

.el-radio {
  display: flex !important;
}

.radio-text {
  display: flex;
  align-items: start;
  max-width: 100%;
  word-break: break-word;
  white-space: normal;
  line-height: 1.5;
}
</style>